var React = require('react');

function Down (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18 1C8.61458 1 0.999999 8.61458 0.999999 18C1 27.3854 8.61458 35 18 35C27.3854 35 35 27.3854 35 18C35 8.61458 27.3854 1 18 1Z","stroke":"black","strokeWidth":"2","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M25.0832 18.5866L17.9998 25.6151L10.9165 18.5866","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M18 24.6378L18 10.3852","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Down.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = Down;

Down.default = Down;
